import { useEffect, useRef } from 'react';
import Card from '@/utils/card';

/**
 * websocket 发送 commonCode to c++
 * @param storeid {string}  commonCode
 * @return {sendServive}
 */

export default function useSendShopInfo() {
  const wsService = useRef<any>(null);

  const close = () => {
    if (wsService.current && wsService.current.socket) {
      wsService.current.close();
      wsService.current = null;
    }
  };

  const sendShopInfo = (service: any, storeid: string) => {
    return service.sendMsg({
      msgtype: 'pusher',
      data: {
        storeid,
      },
    });
  };

  const sendServive = (storeid: string) => {
    if (wsService.current && wsService.current.socket) {
      wsService.current.socket.addEventListener('open', () => {
        sendShopInfo(wsService.current, storeid).then(() => {
          // 发送成功 关闭service
          close();
        });
      });
      wsService.current.socket.addEventListener('error', () => {
        // 接口出错时 重试
        close();
        sendServive(storeid);
      });
    }
  };

  useEffect(() => {
    wsService.current = new Card();
    return () => {
      close();
    };
  }, []);

  return { sendServive };
}
